import { Card, CardMedia, CardContent, Typography, Box } from "@mui/material";
import { AreaCardProps } from "../models";

function AreaCard({ label, value, image, storeNum, handleOnClick }: AreaCardProps) {
  return (
    <Card
      elevation={2}
      sx={{
        cursor: "pointer",
        display: "flex",
        "&:hover": {
          "& .name": {
            color: "primary.main",
            // textDecoration: "underline",
          },
          // opacity: 0.7
        },
      }}
      onClick={() => {
        handleOnClick && handleOnClick(value, label, storeNum);
      }}
    >
      <CardMedia component="img" sx={{ width: 89 }} image={image}></CardMedia>
      <CardContent
        sx={{
          paddingTop: "24px",
          display: "flex",
          alignItems: "center",
          "@media (max-width: 1400px)": {
            flex: "auto",
            flexDirection: "column",
          },
        }}
      >
        <Typography
          className="name"
          fontWeight="bold"
          // fontSize="25px"
          variant="h4"
          sx={{
            mx: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {label}
        </Typography>
        <Box display="flex">
          <Typography
            fontWeight="bold"
            variant="body1"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {storeNum.toString()}
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              ml: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            件
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}

export default AreaCard;
